export { default } from './SpeedDialIcon';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/esm/SpeedDialIcon/index.js
// module id = 890
// module chunks = 2